import { ILifeChangingEvent } from "motw_core/Entity/ILifeChangingEvent";
import * as React from "react";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";

export function ShowRating({ row }: { row: ILifeChangingEvent }) {
    const color = GetColor(row);

    return (
        <span
            className={StyleClassAuto({
                position: `relative`,
                left: `${row.rating}px`,
                justifySelf: `start`,
                color,
                fontSize: `13px`
            })}
        >
            <div style={{ display: "grid", gridTemplateRows: "auto auto" }}>
                <Glyphicon
                    icon={EGlyphicon.certificate}
                    withClass={StyleClassAuto({
                        fontSize: `1px`,
                    })}
                />
                {row.rating ? row.rating : ""}
            </div>
        </span>
    );
}

const GetInterpolatedColor = (
    color1: string,
    color2: string,
    factor: number
) => {
    let result = "#";

    for (let i = 1; i <= 6; i += 2) {
        let v1 = parseInt(color1.slice(i, i + 2), 16);
        let v2 = parseInt(color2.slice(i, i + 2), 16);
        let val = Math.round(v1 + factor * (v2 - v1)).toString(16);

        while (val.length < 2) {
            val = "0" + val;
        }

        result += val;
    }

    return result;
};

function GetColor(row: ILifeChangingEvent) {
    const color1 = `#fcbba3`;
    const color2 = `#c1ffc1`;
    const factor = (row.rating! - 1) / (10 - 1);
    const color = GetInterpolatedColor(color1, color2, factor);
    return color;
}
